import React from 'react';

import NavigationBar from '../components/NavigationBar';
import MediaList from '../components/MediaList';
import Footer from '../components/Footer/Footer';
import Menus from '../components/Menus';
import RestoParameters from '../components/RestoParameters';
import CompanyParameters from '../components/CompanyParameters';
import UserParameters from '../components/UserParameters';
import LogoParameters from '../components/LogoParameters';

function Parameters() {

    return (
        <div>
            <NavigationBar />
            <h1>Paramètres</h1>
            <div className="p-3">
                <RestoParameters />
                <CompanyParameters />
                <UserParameters />
                <LogoParameters />
            </div>
            <MediaList mediaKey='PARAMETERS_BOTTOM' maxItems={1}  isShortLine={true} />
            <Menus />
            <Footer />
        </div>
    );
}

export default Parameters;